import {
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
  Textarea,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMPaymentMethod } from "../../../../model/TblDMPaymentMethod";
import { getPaymentTypeSelect } from "../../../../service/getSelectApi";
import { handleKeyDown } from "../../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../../const/variables";

const EditDataView = ({ id, onClose }: EditDataViewProps) => {
  const entity = {
    id: "0",
    name: null,
    code: null,
    note: null,
    active: false,
    paymentType: null,
    orderBy: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [enable, setEnable] = useState(false);

  const [dataTblPaymentMethodSelect, setDataTblPaymentMethodSelect] = useState<
    ComboboxItem[]
  >([]);

  const form = useForm<TblDMPaymentMethod>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      name: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên hình thức thanh toán!";
        }
        return hasLength(
          { max: 50 },
          "Tên phải nhỏ hơn 150 kí tự!"
        )(value as string);
      },
      code: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập mã hình thức thanh toán!";
        }
        return hasLength(
          { max: 50 },
          "Mã phải nhỏ hơn 50 kí tự!"
        )(value as string);
      },
      paymentType: (value: string | null) => {
        if (!value) {
          return "Vui lòng chọn loại thanh toán!";
        }
      },
      orderBy: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập số thứ tự!";
        }
      },
      note: (value: string | null) => {
        if (value && hasLength({ max: 250 })(value)) {
          return "Ghi chú không quá 250 kí tự!";
        }
      },
    },
  });

  const dataPaymentTypeSelect = async () => {
    const getData = await getPaymentTypeSelect();
    setDataTblPaymentMethodSelect(
      getData
        ?.filter((item) => item.value != null && item.text != null)
        ?.map((item) => ({
          value: item.value,
          label: item.text,
        }))
    );
  };

  const handleEditTblDMPaymentMethod = async (
    dataSubmit: TblDMPaymentMethod
  ) => {
    open();
    const dataApi = await repositoryMdm.post<
      MessageResponse<TblDMPaymentMethod>
    >("/api/v1/TblDmPaymentMethod/update", dataSubmit);
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
      NotificationExtension.Success("Cập nhật thành công!!!");
    }

    close();
  };

  const callApiGetData = async () => {
    open();
    const callapi = await repositoryMdm.get<
      MessageResponse<TblDMPaymentMethod>
    >(`/api/v1/TblDMPaymentMethod/update?id=${id}`);
    if (!callapi?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!!!");
      modals.closeAll();
      return;
    }
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues({
          ...dataApi,
          paymentType: dataApi.paymentType?.toString(),
        });
        form.resetDirty(dataApi);
        await dataPaymentTypeSelect();
      }
      close();
    } else {
      modals.closeAll();
    }
  };

  useEffect(() => {
    if (id) {
      callApiGetData();
    }
  }, [id]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [form]);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        w={{ base: "250px", md: "300px", lg: "400px" }}
        onSubmit={form.onSubmit((e: TblDMPaymentMethod) => {
          handleEditTblDMPaymentMethod(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={6}>
            <TextInput
              label={"Mã hình thức thanh toán"}
              placeholder={"Nhập mã hình thức thanh toán"}
              type="text"
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("code")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label={"Tên hình thức thanh toán"}
              placeholder={"Nhập tên hình thức thanh toán"}
              type="text"
              withAsterisk
              w={"100%"}
              {...form.getInputProps("name")}
            />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={6}>
            <Select
              label={"Loại thanh toán"}
              placeholder={"Chọn loại"}
              data={dataTblPaymentMethodSelect}
              clearable
              searchable
              withAsterisk
              {...form.getInputProps("paymentType")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label={"Số thứ tự"}
              placeholder={"Nhập số thứ tự"}
              type="number"
              withAsterisk
              {...form.getInputProps("orderBy")}
            />
          </Grid.Col>
        </Grid>

        <Grid align="center">
          <Grid.Col span={12}>
            <Textarea
              label={"Ghi chú"}
              placeholder="Nhập ghi chú"
              w={"100%"}
              {...form.getInputProps("note")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox
              label={"Sử dụng"}
              checked={form.values.active}
              {...form.getInputProps("active")}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            disabled={!enable}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default EditDataView;

type EditDataViewProps = {
  id: string | number;
  onClose: any;
};
